import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Nouto',
        [ORDER_METHODS.DELIVERY]: 'Toimitus',
        [ORDER_METHODS.ON_SITE]: 'Pöytätilaus',
      },
    },
    delivery_info: {
      title: 'Toimitustiedot',
      on_arrival: 'Saapuessa:',
    },
    customer_info: {
      title: 'Yhteystiedot',
    },
    payment: {
      title: 'Maksu',
    },
    request_invoice: {
      title: 'Pyydä lasku',
      form: {
        is_receipt_required: {
          label: 'Pyydä lasku sähköpostitse',
        },
      },
    },
    location: {
      title: 'Liikkeen osoite',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Toimitusosoite',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Pöytäsi',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Noutopaikan osoite',
      },
    },
    method: {
      title: 'Tapa',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Toimitus',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Pöytätilaus',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Nouto',
      },
    },
    time: {
      title: 'Aika',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Normaali {{time}} min, tänään',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Ajasta myöhemmäksi',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Soita ovikelloa',
        [DropoffAction.Sms]: 'Ota minuun yhteyttä tekstiviestillä saapuessa',
      },
    },
    doorbell_name: {
      placeholder: 'Ovikellon nimi (valinnainen)',
    },
    company_name: {
      placeholder: 'Yrityksen nimi (valinnainen)',
    },
    customer_note: {
      placeholder: 'Onko ravintolalle jotain huomautettavaa?',
    },
  },
  buttons: {
    change: 'Muuta',
    edit: 'Muokkaa',
    done: 'Valmis',
    add_delivery_note: '+ Lisää toimitustiedot',
    add_order_note: '+ Lisää tilaushuomautus',
  },
  summary: {
    doorbell: 'Ovikello',
    company: 'Yritys',
    note: 'Tilauksen huomautus',
  },
};
